'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogModal = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.KEYCODES = {
      ESC: 27,
      SHIFT: 16,
      TAB: 9
    };
    this.context = context;
    this.els = {
      el: el,
      dialog: context.getElement('.' + this.context.className),
      triggers: context.getElements('.' + this.context.className + '_Trigger'),
      close: context.getElement('.' + this.context.className + '_Close'),
      mask: context.getElement('.' + this.context.className + '_Mask'),
      previousActiveElement: document.activeElement
    };
    this.selectors = {
      focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      video: 'iframe, video',
      image: 'img'
    };
    this.classList = el.classList.value;
    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.handleKeyPresses = this.handleKeyPresses.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.addCssClasses = this.addCssClasses.bind(this);

    this.addCssClasses();
    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    var _this = this;

    this.els.triggers.forEach(function (el) {
      _this.listeners.add(el, 'click', _this.handleTriggerClick);
    });

    // Close dialog via close button or clicking on the background mask
    this.listeners.add(this.els.close, 'click', this.handleCloseClick);
    this.listeners.add(this.els.mask, 'click', this.handleCloseClick);

    // Close dialog using the ESC key regardless of where the user
    document.addEventListener('keydown', this.handleKeyPresses);
  },

  addCssClasses: function addCssClasses() {
    // Ensure videos have the appropriate css class for module styling
    this.els.dialog.querySelectorAll(this.selectors.video).forEach(function (el) {
      var videoCssClass = 'dlg-Modal_Video';
      if (!el.classList.value.includes(videoCssClass)) {
        el.classList = el.classList + ' ' + videoCssClass;
      }
    });

    // Ensure images have the appropriate css class for module styling
    this.els.dialog.querySelectorAll(this.selectors.image).forEach(function (el) {
      var imageCssClass = 'dlg-Modal_Image';
      if (!el.classList.value.includes(imageCssClass)) {
        el.classList = el.classList + ' ' + imageCssClass;
      }
    });
  },
  handleTriggerClick: function handleTriggerClick(e) {
    var _this2 = this;

    e.preventDefault();

    // Ensure we record the active element at the time the dialog was opened
    // so we can take the user back to it when it closes
    this.els.previousActiveElement = document.activeElement;

    this.els.el.classList = this.els.el.classList + ' ' + this.context.className + '_Open';

    (0, _functional.fadeIn)(this.els.dialog).then(function () {
      return _this2.els.dialog.setAttribute('aria-hidden', 'false');
    });

    // Move focus into dialog
    this.els.close.focus();

    return false;
  },
  handleCloseClick: function handleCloseClick(e) {
    var _this3 = this;

    (0, _functional.fadeOut)(this.els.dialog).then(function () {
      _this3.els.dialog.setAttribute('aria-hidden', 'true');
      _this3.els.el.classList = _this3.els.el.classList.value.replace(' ' + _this3.context.className + '_Open', '');
    });

    // Move focus back to the previously active element
    this.els.previousActiveElement.focus();

    // This ensures an embeded video stops playback when the dialog is closed
    this.els.dialog.querySelectorAll(this.selectors.video).forEach(function (el) {
      if (el.tagName.toLowerCase() === 'video') {
        el.pause();
        el.currentTime = 0;
      } else if (el.tagName.toLowerCase() === 'iframe') {
        el.setAttribute('src', el.getAttribute('src'));
      }
    });
  },
  handleKeyPresses: function handleKeyPresses(e) {
    // Close the dialog using the ESC key
    if (e.keyCode === this.KEYCODES.ESC) {
      this.handleCloseClick(e);
    }

    var isTabPressed = e.key === 'Tab' || e.keyCode === this.KEYCODES.TAB;

    // Allow other keys to behave as normal
    if (!isTabPressed) {
      return;
    }

    // Define the focusable elements
    var focusableElements = this.els.dialog.querySelectorAll(this.selectors.focusable);
    // Get first element to be focused inside modal
    var firstFocusableElement = focusableElements[0];
    // Get last element to be focused inside modal
    var lastFocusableElement = focusableElements[focusableElements.length - 1];

    // If shift key pressed for shift + tab combination
    if (e.shiftKey || e.keyCode === this.KEYCODES.SHIFT) {
      // Focus on the last focusable element
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        // Focus first focusable element after last element has been focused
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  }
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var dialogModal = (0, _create2.default)(DialogModal);
  dialogModal.init({ el: el, context: context });
}